import {Box, Grid, Typography} from "@mui/material";
import DocIcon from "../assets/icons/docIcon.png";
import React from "react";
import {formatCustomDate} from "../utils/utils";


const DocComponent = ({ dossier, onClick }) => {



    return (
        <Grid item xs={12} sm={2}
              display="flex" flexDirection="column"
              justifyContent="center" alignItems="center"
              onClick={onClick}
              sx={{ cursor: 'pointer' }}
        >
            <Box display="flex" flexDirection="column" justifyContent="center"
                 alignItems="center" sx={{
                border: '1px solid #D7D7D7',
                borderRadius: '5px',
                height: '150px',
                width: '150px',
            }}>
                <img src={DocIcon} alt="logo" style={{width: '100px', height: '100px'}}/>
                <Typography variant="p">DOS-{dossier.id}</Typography>
            </Box>
            <Typography variant="h6">{formatCustomDate(dossier?.dateCreated)}</Typography>
        </Grid>
    )
}

export default DocComponent;